import api from '../config/api';

const liquidacionService = {
  /**
   * Lista liquidaciones generadas
   * GET /api/liquidaciones?empresa_id=
   */
  list: async (empresaId) => {
    const response = await api.get('/liquidaciones', {
      params: { empresa_id: empresaId },
    });
    return response.data;
  },

  /**
   * Guardar liquidación generada
   * POST /api/liquidaciones
   */
  store: async (payload) => {
    const response = await api.post('/liquidaciones', payload);
    return response.data;
  },

  /**
   * Empleados cesados con fecha ingreso y salida (paginado 20, búsqueda)
   * GET /api/liquidaciones/empleados-cesados?empresa_id=&page=1&search=
   */
  getEmpleadosCesados: async (empresaId, page = 1, search = '') => {
    const params = { empresa_id: empresaId, page };
    if (search && search.trim()) params.search = search.trim();
    const response = await api.get('/liquidaciones/empleados-cesados', { params });
    return response.data;
  },

  /**
   * Calcular liquidación (gratificación, CTS, vacaciones) para empleados cesados
   * GET /api/liquidaciones/calcular?empresa_id=
   */
  calcular: async (empresaId) => {
    const response = await api.get('/liquidaciones/calcular', {
      params: { empresa_id: empresaId },
    });
    return response.data;
  },

  /**
   * Eliminar una liquidación
   * DELETE /api/liquidaciones/{id}
   */
  destroy: async (id) => {
    const response = await api.delete(`/liquidaciones/${id}`);
    return response.data;
  },
};

export default liquidacionService;
